import axios from 'axios'

export const putContactAddressFavorite = async (contactAddress: any) => {
  return await axios.put(
    `${process.env.REACT_APP_API_URL}/contactAddress/${contactAddress.id}/favorite`,
    contactAddress,
    {
      withCredentials: true,
    },
  )
}
